const PsychologicalMovies = [
  {
    id: 1,
    title: "The Boy Next Door",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABYeq5IKLP5vp2xsBxoWlx8SVZJCF6Z0kHexdz58_yWp_U_my0K0s_iK7EBsfGBlCIwt7-8VnVjapX3Gub6-C5jd004MU_a8SHbQ.jpg?r=1f4",
  },
  {
    id: 2,
    title: "Usogui",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABaN25ylzhduNLHD5pQC4mXWhLmml_-tr6ZdSy-wmGY_YC2hGRx85skrLpkQEz_WDNOEit4-2N5YngzebUdocaktKNyFIxLULy6U.jpg?r=fdd",
  },

  {
    id: 3,
    title: "Torbaaz",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdVqb58kEAvTbPUO_y9_L3R4NyQ3oiGayeJQvA1M9Xq422s9kLLUnFaexrG34z-_b8r1Uv3yKKKkMNrGk1ZuJtB-6ao6IDYnsuQ.jpg?r=0b7",
  },
  {
    id: 4,
    title: "Two",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfjf3h4e4MQdcvxvjJ-Fk4woko9i6lA_-3IRfaeua7bJFNaRBzglfuAx8MhcgKqBRnQCD7bmdKsBom0rc1dR1J2pYBnhI64FBXijazMBPbSioAZLNb63NsG_EJIBkQBUaQdq.jpg?r=5a6",
  },

  {
    id: 5,
    title: "The Roommate",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABbxWrYfyOvipCgl-btpqrsedK_yTaYfZKowytyac6h_Ho3flHso0DFWUbo-kKfFAvd5WMeT_AOiBar8nEPWILunEM4tmICh_Hz8.jpg?r=f84",
  },
  {
    id: 6,
    title: "Haseen Dilruba",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRGvacNxiifJo6sioy2Su-z2rNuTGHG5XfAaHaAAEF--vGyi2w3gbIRo9MKbqRO2iq4LT42Xsi03X9lOgBpEPEspHIuLfQVHGeGvpBMrMwto9JmAloyJA6QdNt3noFKY0gTR.jpg?r=f8a",
  },
  {
    id: 7,
    title: "Hamid",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfx754gsDF-5InoAx8zRrdDawfFEyOjD--82x6TGJYlinpZQ0dodL5lBlSr41A2sGZgQDLSTunhFs96lTTpQ7nx0LWPk1WynD0Y.jpg?r=df5",
  },
  {
    id: 8,
    title: "Don't Listen",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRLO2wVJrQDqeL2xvp0cNUFnkO1-wuwVoY4q5p7pHYCVjdWLAAcwY0GPt9Ud2huNtWiDLowo8TkxRM3LjVVONUZYCxS2q5I_BzShXqRnPHihvLCBU1n7Zl3sTvpbU5SbZll_.jpg?r=f46",
  },
  {
    id: 9,
    title: "Deadly Illusion",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABShuseRe2dzV6CkZwT1YyTl_t8jKNKHsUg-wu3B_4F1Q5xVD5CvV9Rwt3sN2vvYtHTpNK-bs_9JPY79RNFTS2O2TJmtEoRehQAQ.jpg?r=a04",
  },
  {
    id: 10,
    title: "The Platform",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABZGey-dQ5Q7TciLzZ_zWjYMeUMjPdhzTJF5y3tKTXgnSjEC2sk06GyPEcsgRjEAUQnMXfy4aP4FsMqN73mkyMWsWi0YHIaSH4RDkTvld8L3AVjdH8bBo6nyypz0UYjd534TY.jpg?r=fc2",
  },
  {
    id: 11,
    title: "Baazar",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABWdWu0xSbEdNcveCelYhE4PO9EJ5L2khSnndAhaC9CxHOL1oWssPeLf46AL3qJ08sBNSXFSllslqO9Ovf2uNH_ddS-kPzMYc2zY.jpg?r=f1b",
  },
  {
    id: 12,
    title: "The Girl On The Train ",
    img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfaD3w1839VJiIQKRZt0L9TIfeHTrgIcy1a4NVt5zEMPhFK6R798xbJwBC1F5c2RaIuWoKjSxYUF10vC6Mjt9kc3D024uCHm_B08sFMacW0rpWNgomtdwdFc_c6PrQ-KH3jE.jpg?r=54e",
  },
];

export default PsychologicalMovies;
